<template>
    <Header></Header>
        <main> 
            <BreadCrumbs></BreadCrumbs>
            <MainContent :array="arr_data"></MainContent>
            <OurBlog v-if="fields['Our Blog']" :fields="fields['Our Blog']" style="padding-top: 140px;" :array="blogs"></OurBlog>
            <PosotionImgContent
            :content="{
                imagePosition: 'right'
            }"
            ></PosotionImgContent>
            <FaqBlock style="padding-top: 140px; padding-bottom: 140px;"></FaqBlock>
        </main>
    <Footer></Footer>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import Footer from "@/components/Footer/Footer.vue";
import BreadCrumbs from "@/components/UI/BreadCrumbs.vue";
import OurBlog from "@/components/Templates/OurBlog.vue";
import FaqBlock from "@/components/Templates/FaqBlock.vue";
import PosotionImgContent from "@/components/Templates/PosotionImgContentRight.vue";
import MainContent from "@/components/BlogArticle/MainContent.vue";
import axios from "axios";
export default {
    components: {
        Header,
        Footer,
        BreadCrumbs,
        FaqBlock,
        PosotionImgContent,
        OurBlog,
        MainContent
    },
    data() {
        return {
            arr_data: [],
            blogs: [],
        }
    },
    methods: {
        getData() {
            let fData = new FormData();
            fData.append("slug", this.$route.params.slug);
            axios.post("/get/blog-post", fData).then(resp => {
                if (resp.data.result == true) {
                this.arr_data = resp.data.blog;
                this.updateTitle(this.arr_data[0].meta_title ? this.arr_data[0].meta_title : "UBL");
                if(this.arr_data[0].meta_description){
                    this.updateMetaDescription(this.arr_data[0].meta_description);
                }

                }
            }).catch(() => {
            }).finally(() => {
            });
        },
        async fetchBlogs() {
            try {
                const response = await axios.get("/get/our-blogs");
                if (response.data.result) {
                this.blogs = response.data.blog;
                
                }
            } catch (error) {
                console.error("Ошибка при загрузке блогов:", error);
            }
        },
        updateTitle(title) {
            let titleTag = document.querySelector("title");
            if (!titleTag) {
                titleTag = document.createElement("title");
                document.head.appendChild(titleTag);
            }
            titleTag.textContent = title || "UBL";
        },

        updateMetaDescription(content) {
            let tag = document.querySelector(`meta[name='description']`);
            if (tag) {
                tag.setAttribute("content", content);
            } else {
                tag = document.createElement("meta");
                tag.setAttribute("name", "description");
                tag.setAttribute("content", content);
                document.head.appendChild(tag);
            }
        }
    },
    computed: {
            fields() {
                return this.$store.state.fields;
            },
        },
    mounted () {
        this.getData();
        this.fetchBlogs();
    },
    watch: {
        // Следим за изменением slug в маршруте
        '$route.params.slug': function(newSlug) {
        this.getData(); // Перезапрашиваем пост по новому slug
        },
    },
}
</script>

<style scoped>

</style>